import React from "react";
import logo from "../images/v-health-logo.png";

export default function Header() {
  return (
    <header>
      <nav className="navbar navbar-dark bg-dark navbar-expand-lg navbar-light bg-light">
        <a className="navbar-brand bg-dark" href="/">
          <img
            src={logo}
            width="50"
            height="50"
            alt="V-health-logo"
            loading="lazy"
          />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item active">
              <a className="nav-link" href="/">
                Home <span className="sr-only">(current)</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/patient/login">
                Login Patients
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/admin/login">
                Login Providers
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/admin/provider/registration">
                SignUp Providers
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/users/login">
                Administration
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}
